export const GET_TCIN_INFO_DATA = 'GET_TCIN_INFO_DATA'
export const SET_MAX_ALT_IMAGE_COUNT = 'SET_MAX_ALT_IMAGE_COUNT'
export const SET_SHOW_CONTENT = 'SET_SHOW_CONTENT'
export const SET_ERROR_TYPE = 'SET_ERROR_TYPE'
export const SET_ERROR_LIST = 'SET_ERROR_LIST'
export const SET_COLUMN_MAP = 'SET_COLUMN_MAP'
export const SET_TEMP_COLUMN_MAP = 'SET_TEMP_COLUMN_MAP'
export const SET_LAYOUT = 'SET_LAYOUT'
export const SET_TEMP_LAYOUT = 'SET_TEMP_LAYOUT'
export const SET_USER_COL_MAP = 'SET_USER_COL_MAP'
export const SET_CUSTOMIZED_VIEW = 'SET_CUSTOMIZED_VIEW'
export const SET_APPLIED_VIEW = 'SET_APPLIED_VIEW'
export const SET_IS_APPLY_DISABLED = 'SET_IS_APPLY_DISABLED'
export const SET_IS_SAVE_DISABLED = 'SET_IS_SAVE_DISABLED'
export const SORTED_TCIN_INFO_DATA = 'SORTED_TCIN_INFO_DATA'
export const ENLARGE_IMAGE = 'ENLARGE_IMAGE'
export const SET_FILTER_DATA = 'SET_FILTER_DATA'
export const GROUPING_TREE_DATA = 'GROUPING_TREE_DATA'
export const TREE_LIST_DATA = 'TREE_LIST_DATA'
export const SELECTED_TCIN_DATA = 'SELECTED_TCIN_DATA'
export const SELECTED_FILTER_TCINS = 'SELECTED_FILTER_TCINS'
export const DATA_FILTERED = 'DATA_FILTERED'
export const USER_FILTERS = 'USER_FILTERS'
